const state = {
    cases: [
        {
            id: 1,
            heading: 'Завод Экран',
            customer: 'Завод Экран',
            city: 'Новосибирск',
            year: '2018',
            task: 'Ричард МакКлинток профессор латыни из колледжа Hampden-Sydney, штат Вирджиния, взял одно из самых' +
            ' странных слов в Lorem Ipsum, "concestetur", и занялся поискми его в классической латинской' +
            'литературе. В результате он нашел неоспоримый первоисточник.',
            solution: 'Есть много вариантов Lorem Ipsum, но большинство из них имеет не всегда приемлемые ' +
            'модификации, например, юмористические вставки или слова, которые даже отдалённо не напоминают латынь. ' +
            'Если вам нужен Lorem Ipsum для серьёзного проекта, вы наверняка',
            photos: [
                'img1.png', 'img_2.png', 'img_3.png'
            ],
            solutionNext: ' не хотите какой-нибудь шутки, скрытой ' +
            'в середине абзаца. Также все другие известные генераторы Lorem Ipsum используют один и тот же текст, ' +
            'который они просто повторяют, пока не достигнут нужный объём. Это делает предлагаемый здесь генератор ' +
            'единственным настоящим Lorem Ipsum генератором. Он использует словарь из более чем 200 латинских слов, ' +
            'а также набор моделей предложений.',
            result: 'Ричард МакКлинток профессор латыни из колледжа Hampden-Sydney, штат Вирджиния, взял одно из самых' +
            ' странных слов в Lorem Ipsum, "concestetur", и занялся поискми его в классической латинской' +
            'литературе. В результате он нашел неоспоримый первоисточник.',
            image: 'case_01_b.png',
            imageThumbnail: 'case_s_1.png',
            path: '/cases/1',
        },
        {
            id: 2,
            heading: 'СНТ Монолит',
            customer: 'СНТ Монолит',
            city: 'Новосибирск',
            year: '2018',
            task: 'Ричард МакКлинток профессор латыни из колледжа Hampden-Sydney, штат Вирджиния, взял одно из самых' +
            ' странных слов в Lorem Ipsum, "concestetur", и занялся поискми его в классической латинской' +
            'литературе. В результате он нашел неоспоримый первоисточник.',
            solution: 'Есть много вариантов Lorem Ipsum, но большинство из них имеет не всегда приемлемые ' +
            'модификации, например, юмористические вставки или слова, которые даже отдалённо не напоминают латынь. ' +
            'Если вам нужен Lorem Ipsum для серьёзного проекта, вы наверняка',
            photos: [
                'img1.png', 'img_2.png', 'img_3.png'
            ],
            solutionNext: ' не хотите какой-нибудь шутки, скрытой ' +
            'в середине абзаца. Также все другие известные генераторы Lorem Ipsum используют один и тот же текст, ' +
            'который они просто повторяют, пока не достигнут нужный объём. Это делает предлагаемый здесь генератор ' +
            'единственным настоящим Lorem Ipsum генератором. Он использует словарь из более чем 200 латинских слов, ' +
            'а также набор моделей предложений.',
            result: 'Ричард МакКлинток профессор латыни из колледжа Hampden-Sydney, штат Вирджиния, взял одно из самых' +
            ' странных слов в Lorem Ipsum, "concestetur", и занялся поискми его в классической латинской' +
            'литературе. В результате он нашел неоспоримый первоисточник.',
            total: '',
            image: 'case_01_b.png',
            imageThumbnail: 'case_02_s.png',
            path: '/cases/2',
        },
        {
            id: 3,
            heading: 'ФГУП ЖКХ ННЦ',
            customer: 'ФГУП ЖКХ ННЦ',
            city: 'Новосибирск',
            year: '2018',
            task: 'Ричард МакКлинток профессор латыни из колледжа Hampden-Sydney, штат Вирджиния, взял одно из самых' +
            ' странных слов в Lorem Ipsum, "concestetur", и занялся поискми его в классической латинской' +
            'литературе. В результате он нашел неоспоримый первоисточник.',
            solution: 'Есть много вариантов Lorem Ipsum, но большинство из них имеет не всегда приемлемые ' +
            'модификации, например, юмористические вставки или слова, которые даже отдалённо не напоминают латынь. ' +
            'Если вам нужен Lorem Ipsum для серьёзного проекта, вы наверняка',
            photos: [
                'img1.png', 'img_2.png', 'img_3.png'
            ],
            solutionNext: ' не хотите какой-нибудь шутки, скрытой ' +
            'в середине абзаца. Также все другие известные генераторы Lorem Ipsum используют один и тот же текст, ' +
            'который они просто повторяют, пока не достигнут нужный объём. Это делает предлагаемый здесь генератор ' +
            'единственным настоящим Lorem Ipsum генератором. Он использует словарь из более чем 200 латинских слов, ' +
            'а также набор моделей предложений.',
            result: 'Ричард МакКлинток профессор латыни из колледжа Hampden-Sydney, штат Вирджиния, взял одно из самых' +
            ' странных слов в Lorem Ipsum, "concestetur", и занялся поискми его в классической латинской' +
            'литературе. В результате он нашел неоспоримый первоисточник.',
            image: 'case_01_b.png',
            imageThumbnail: 'case_03_s.png',
            path: '/cases/3',
        },
        {
            id: 4,
            heading: 'УК Степная',
            customer: 'УК Степная',
            city: 'Новосибирск',
            year: '2018',
            task: 'Ричард МакКлинток профессор латыни из колледжа Hampden-Sydney, штат Вирджиния, взял одно из самых' +
            ' странных слов в Lorem Ipsum, "concestetur", и занялся поискми его в классической латинской' +
            'литературе. В результате он нашел неоспоримый первоисточник.',
            solution: 'Есть много вариантов Lorem Ipsum, но большинство из них имеет не всегда приемлемые ' +
            'модификации, например, юмористические вставки или слова, которые даже отдалённо не напоминают латынь. ' +
            'Если вам нужен Lorem Ipsum для серьёзного проекта, вы наверняка',
            photos: [
                'img1.png', 'img_2.png', 'img_3.png'
            ],
            solutionNext: ' не хотите какой-нибудь шутки, скрытой ' +
            'в середине абзаца. Также все другие известные генераторы Lorem Ipsum используют один и тот же текст, ' +
            'который они просто повторяют, пока не достигнут нужный объём. Это делает предлагаемый здесь генератор ' +
            'единственным настоящим Lorem Ipsum генератором. Он использует словарь из более чем 200 латинских слов, ' +
            'а также набор моделей предложений.',
            result: 'Ричард МакКлинток профессор латыни из колледжа Hampden-Sydney, штат Вирджиния, взял одно из самых' +
            ' странных слов в Lorem Ipsum, "concestetur", и занялся поискми его в классической латинской' +
            'литературе. В результате он нашел неоспоримый первоисточник.',
            image: 'case_01_b.png',
            imageThumbnail: 'case_04_s.png',
            path: '/cases/4',
        }
    ]
}

export default {
    state
}


// WEBPACK FOOTER //
// ./src/store/modules/cases/cases.js